import { render, staticRenderFns } from "./CrossDockForm.vue?vue&type=template&id=63ef0e72"
import script from "./CrossDockForm.vue?vue&type=script&lang=js"
export * from "./CrossDockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports